<template>
  <v-app class="select-language">
    <tool-bar v-if="(!extendConvertVisaDetail.is_reciprocity) || (extendConvertVisaDetail.is_reciprocity && today_date > extendConvertVisaDetail.expiry_date)">
      <slot><h3>{{ extendConvertVisaDetail.visa_type }} Extension Confirmation</h3></slot>
    </tool-bar>

    <v-content class="pt-0">
      <v-container v-if="(!extendConvertVisaDetail.is_reciprocity) || (extendConvertVisaDetail.is_reciprocity && today_date > extendConvertVisaDetail.expiry_date)" fluid>
        <form-error-display-handler :errors="errors"/>
        <v-layout justify-center>
          <v-card>
            <v-toolbar class="elevation-0" color="none">
              <v-toolbar-title>
                <b class="text-primary">Dear {{ extendConvertVisaDetail.full_name }} , please confirm your
                  information:</b>
              </v-toolbar-title>
              <v-spacer/>
            </v-toolbar>

            <v-card-text class="pt-0">
              <v-layout row wrap>

                <v-flex class="mx-3" xs12>
                  <late-info-message v-if="extendConvertData.overstay_processing == 1"
                                     :overstay="1"/>
                  <late-info-message v-else :cost="total_cost"/>
                </v-flex>

                <confirmation-header-text class="ml-3" icon="mdi-equal-box"
                                          text="Extend Information"/>

                <v-flex sm3 xs12>
                  <list-item-detail
                      :sub_title="extendConvertData.days_staying + ' days ('+extendConvertData.plan_name+')'"
                      :title="$vuetify.lang.t('$vuetify.visa_duration')"/>
                </v-flex>
                <v-flex sm3 xs12>
                  <list-item-detail
                      :sub_title="extendConvertData.start_date + ' to '+ extendConvertData.expiry_date"
                      :title="$vuetify.lang.t('$vuetify.visa_period')"/>
                </v-flex>
                <v-flex sm3 xs12 v-if="extendConvertData.overstay_processing != 1">
                  <list-item-detail
                      :sub_title="'$ '+(total_cost - late_fee)"
                      title="Visa Fee (USD)"
                  />
                </v-flex>
                <v-flex sm3 xs12 v-if="late_fee>0 && extendConvertData.overstay_processing != 1">
                  <list-item-detail
                      :sub_title="'$ '+late_fee"
                      title="Late Fee (USD)"
                  />
                </v-flex>

                <v-flex sm3 xs12 v-if="extendConvertData.overstay_processing != 1">
                  <list-item-detail
                      :sub_title="'$ '+total_cost"
                      title="Total Fee(USD)"
                  />
                </v-flex>
                <v-flex sm3 xs12>
                  <list-item-detail :sub_title="extendConvertData.purpose_of_visa"
                                    :title="$vuetify.lang.t('$vuetify.reason_for_extend')"/>
                </v-flex>
                <v-flex sm3 xs12>
                  <list-item-detail :sub_title="extendConvertData.appointment_date"
                                    title="Appointment Date"/>
                </v-flex>

                <v-flex xs12>
                  <v-divider class="my-1"/>
                </v-flex>

                <v-flex class="pt-0 px-0" xs12>
                  <visa-detail :visa="extendConvertVisaDetail" header-text="Current Visa Details"/>
                </v-flex>

                <v-flex xs12 v-if="extendConvertData.documents && extendConvertData.documents.length > 0">
                  <v-divider class="my-1"/>
                </v-flex>

                <documents class="mx-6" :documents="extendConvertData.documents"
                           headerText="Documents to submit"/>

	              <v-flex xs12 v-if="extendConvertData.required_documents && Object.keys(extendConvertData.required_documents).length">
		              <v-divider class="my-1"/>
	              </v-flex>
	              <identity-documents
			              v-if="extendConvertData.required_documents && Object.keys(extendConvertData.required_documents).length"
			              class="mx-6"
			              :documents="extendConvertData.required_documents"
			              headerText="Identify Documents"
	              />

                <v-flex xs12>
                  <v-divider class="my-1"/>
                </v-flex>
                <component v-bind:is="selected_visa_type"/>
                <v-flex xs12>
                  <v-divider class="my-1"/>
                </v-flex>
                <v-flex md12 xs12 class="pt-3">

                  <v-btn
                      @click="proceedExtendVisa" class="pull-right mr-2"
                      color="primary"
                      :loading="loading"
                      large>
                    Submit
                  </v-btn>
                  <v-btn
                      @click="back" class="pull-right mr-2 px-2"
                      color="error"
                      large>
                    Back
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-card-text>

          </v-card>
        </v-layout>

      </v-container>
      <v-flex  class="px-5 pt-10" xs12 v-if="extendConvertVisaDetail.is_reciprocity && today_date < extendConvertVisaDetail.expiry_date">
        <v-alert class="mb-7"
                 outlined
                 type="info"
        >
          This is reciprocity visa.No need to do any confirmation for extension of reciprocity visa. All the setup will be done by administration section.
        </v-alert>
      </v-flex>
      <v-flex md12 xs12 class="pt-3"  v-if="extendConvertVisaDetail.is_reciprocity && today_date < extendConvertVisaDetail.expiry_date">

        <v-btn
            @click="proceedExtendVisa" class="pull-right mr-2"
            color="primary"
            :loading="loading"
            large>
          Submit
        </v-btn>
        <v-btn
            @click="back" class="pull-right mr-2 px-2"
            color="error"
            large>
          Back
        </v-btn>
      </v-flex>
    </v-content>
  </v-app>

</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import VisaDetail from "../VisaDetail";
import BusinessVisa from '../../components/visa/confirm/BusinessVisa'
import DependentVisa from '../../components/visa/confirm/DependentVisa'
import MarriageVisa from '../../components/visa/confirm/MarriageVisa'
import NRNVisa from '../../components/visa/confirm/NRNVisa'
import RelationVisa from '../../components/visa/confirm/RelationVisa'
import ResidentialVisa from '../../components/visa/confirm/ResidentialVisa'
import StudyVisa from '../../components/visa/confirm/StudyVisa'
import TouristVisa from '../../components/visa/confirm/TouristVisa'
import TransitVisa from '../../components/visa/confirm/TransitVisa'
import WorkingVisa from '../../components/visa/confirm/WorkingVisa'
import PressVisa from '../../components/visa/confirm/PressVisa'
import ConfirmationHeaderText from '../../components/ConfirmationHeaderText'
import ToolBar from "../../components/ToolBar";
import ListItemDetail from "../../components/ListItemDetail";
import LateInfoMessage from "../../components/LateInfoMessage";
import FileDisplay from '../../components/FileDisplay'
import FileListItemDetail from '../../components/FileListItemDetail'
import {VISA_PLANS} from "../../constant/appConstant";
import Documents from "../../components/Documents";
import FormErrorDisplayHandler from "../../components/FormErrorDisplayHandler";
import moment from "moment";
import IdentityDocuments from "../../components/IdentityDocuments";

export default {
  name: "ExtendConfirm",
  components: {
	  IdentityDocuments,
    Documents,
    VisaDetail,
    "marriage-visa": MarriageVisa, ConfirmationHeaderText,
    "dependent-visa": DependentVisa,
    "nrn-visa": NRNVisa,
    "relation-visa": RelationVisa,
    "residential-visa": ResidentialVisa,
    "study-visa": StudyVisa,
    "tourist-visa": TouristVisa,
    "transit-visa": TransitVisa,
    "working-visa": WorkingVisa,
    "business-visa": BusinessVisa,
    "press-visa": PressVisa, ToolBar, ListItemDetail,
    LateInfoMessage,
    FileDisplay,
    FileListItemDetail,
    FormErrorDisplayHandler
  },
  data() {
    return {
      today_date:moment().format('YYYY-MM-DD'),
      background: require("@/assets/background.jpg"),
      visa_plans: VISA_PLANS,
      errors: []
    }
  },
  // beforeRouteEnter(to, from, next) {
  //
  //     if (!from.name || from.name === 'PrintForm') {
  //         next(vm => {
  //             vm.$router.push({
  //                 name: 'ExtendChangeVisa'
  //             })
  //         })
  //     }
  //     next();
  // },
  methods: {
    ...mapActions({
      submitVisaExtend: "VisaSingle/submitExtendVisa",
    }),
    back() {
      this.extendConvertData.overstay_processing = 0;
      this.$router.go(-1);
    },
    proceedExtendVisa() {
      this.submitVisaExtend({
        extend_time: this.extendConvertData.days_staying,
        reason: this.extendConvertData.purpose_of_visa,
        start_date: this.extendConvertData.start_date,
        dependent_visa_number: this.extendConvertData.extend_dependent_passport_number,
        dependent_passport_number: this.extendConvertData.extend_dependent_visa_number,
        isIndianHost: this.extendConvertData.isIndianHost
      }).then((res) => {
        // this.$store.commit("VisaSingle/resetState");
        this.$store.commit("VisaSingle/setPrintResponse", res.data);
        this.$router.push({
          name: 'PrintForm'
        })
      }).catch((e) => {
        this.$store.commit('Notification/showError', e.response.data.message);
        this.errors = e.response.data.errors;
      })
    }
  },
  computed: {
    ...mapGetters('VisaSingle', ['visa', 'convert_visa_options', 'extra_data', 'visaCatOptions', 'extendConvertData', 'extendConvertVisaDetail', 'loading']),
    ...mapGetters('VisaType', ['conditions', 'visa_type_slug', 'late_cost']),

    visaPlan() {
      return this.visaCatOptions.find((i) => i.value === this.extendConvertData.visaPlan);
    },
    selected_visa_type() {
      if (this.extendConvertVisaDetail.dependent_visa)
        return "dependent-visa";
      return this.extendConvertVisaDetail.slug;
    },
    total_cost() {
      let cost = parseInt(this.extendConvertData.cost);
      if (cost > 0 || this.late_cost > 0) {
        if (this.extendConvertData.overstay_processing == 1){
          cost += this.extendConvertVisaDetail.late_days * 5;
        }
        else {
          cost += this.late_cost
        }
      }
      return cost;
    },
    late_fee() {
      if (this.extendConvertData.overstay_processing == 1){
        return this.extendConvertVisaDetail.late_days * 5
      }
      return this.late_cost;
    }
  }
}
</script>
